import '../../../Optics/Dialog/styleDialog.css';
import CustomSnackbar from '../../../Optics/Components/CustomSnackbar';
import React from 'react';
import { CONST_CANTON, CONST_CANTON_COUPLING, CONST_CANTON_FOB, CONST_CANTON_PON_BOX} from '../../../Optics/Constants/ConstantsOptics';
import CableDescriptConstruction from './CableDescriptConstruction';
import CouplingDescriptConstruction from './CouplingDescriptConstruction';
import FobDescriptConstruction from './FobDescriptConstruction';
import PonBoxDescriptConstruction from './PonBoxDescriptConstruction';

const DescriptionComponentModalConstr = ({ open, onClose, content, markerType,isLineDrawing, couplingMarker, fobMarker, 
      ponBoxMarker, changeLinkEditing, linkEditing, cantonFobRefresh, cantonCouplingRefresh, cantonPonBoxRefresh,
      cantonCablaRefresh, setIsComponentСhangeCoorCoupling, setIsComponentСhangeCoorFob, setIsComponentСhangeCoorPonBox,
      cantonCablaByIdRefresh}) => {
 
const { showSnackbar, snackbarOpen, handleCloseSnackbar, snackbarMessage, snackbarClass } = CustomSnackbar();

const copyToClipboard = (text, type) => {
  const textarea = document.createElement("textarea");
  textarea.value = text;
  document.body.appendChild(textarea);
  textarea.select();
  textarea.focus(); 
  try {
    const successful = document.execCommand("copy");
    if (successful) {
      showSnackbar('Скопировано: ' + type + ': ' + text, 'snackbarOk');
    } else {
      showSnackbar('Не удалось скопировать ID в буфер обмена', 'snackbarError');
    }
  } catch (err) {
    showSnackbar('Не удалось скопировать ID в буфер обмена', 'snackbarError');
  }
  document.body.removeChild(textarea);
};

 
 if (markerType === CONST_CANTON && !(isLineDrawing || couplingMarker|| fobMarker || ponBoxMarker) && !linkEditing) {
    return (
      <CableDescriptConstruction
        open={open}
        onClose={onClose}
        content={content}
        snackbarOpen={snackbarOpen}
        snackbarMessage={snackbarMessage}
        snackbarClass={snackbarClass}
        handleCloseSnackbar={handleCloseSnackbar}
        copyToClipboard={copyToClipboard}
        changeLinkEditing={changeLinkEditing}
        cantonRefresh={cantonCablaRefresh}
        cantonCablaByIdRefresh={cantonCablaByIdRefresh}
      />
    );
  }
  else if (markerType === CONST_CANTON_COUPLING && !(isLineDrawing || couplingMarker|| fobMarker || ponBoxMarker)) {
    return (
      <CouplingDescriptConstruction
        open={open}
        onClose={onClose}
        content={content}
        snackbarOpen={snackbarOpen}
        snackbarMessage={snackbarMessage}
        snackbarClass={snackbarClass}
        handleCloseSnackbar={handleCloseSnackbar}
        copyToClipboard={copyToClipboard}
        cantonCouplingRefresh={cantonCouplingRefresh}
        setIsComponentСhangeCoorCoupling={setIsComponentСhangeCoorCoupling}
      />
    );
  }
  else if (markerType === CONST_CANTON_FOB && !(isLineDrawing || couplingMarker|| fobMarker || ponBoxMarker)) {
    return (
      <FobDescriptConstruction
        open={open}
        onClose={onClose}
        content={content}
        snackbarOpen={snackbarOpen}
        snackbarMessage={snackbarMessage}
        snackbarClass={snackbarClass}
        handleCloseSnackbar={handleCloseSnackbar}
        copyToClipboard={copyToClipboard}
        cantonFobRefresh={cantonFobRefresh}
        setIsComponentСhangeCoorFob={setIsComponentСhangeCoorFob}
      />
    );
  }
  else if (markerType === CONST_CANTON_PON_BOX && !(isLineDrawing || couplingMarker|| fobMarker || ponBoxMarker)) {
    return (
      <PonBoxDescriptConstruction
        open={open}
        onClose={onClose}
        content={content}
        snackbarOpen={snackbarOpen}
        snackbarMessage={snackbarMessage}
        snackbarClass={snackbarClass}
        handleCloseSnackbar={handleCloseSnackbar}
        copyToClipboard={copyToClipboard}
        cantonRefresh={cantonPonBoxRefresh}
        setIsComponentСhangeCoorPonBox={setIsComponentСhangeCoorPonBox}
      />
    );
  }
  else {
    return null; 
  }
  }
 
export default DescriptionComponentModalConstr;